<template>
  <v-app class="split-bg">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4 lg4>
            <v-card class="elevation-1 pa-3">
              <v-card-text>
                <div class="layout column align-center">
                  <v-img
                    :src="settings.branding.logo"
                    alt="Vue Material Admin"
                    max-width="266"
                    max-height="200"
                  />
                </div>
                <v-form autocomplete="off">
                  <v-text-field
                    v-model="user.firstName"
                    append-icon="person"
                    label="First Name"
                    type="text"
                    readonly
                  />
                  <v-text-field
                    v-model="user.lastName"
                    append-icon="person"
                    label="Last Name"
                    type="text"
                    readonly
                  />
                  <v-text-field
                    v-model="user.email"
                    append-icon="person"
                    label="Email"
                    type="text"
                    readonly
                  />
                  <v-text-field
                    v-model="user.phoneNumber"
                    append-icon="phone"
                    label="Phone #"
                    type="text"
                  />
                  <v-text-field
                    v-model="user.password"
                    append-icon="lock"
                    label="Password"
                    type="password"
                  />
                  <v-text-field
                    v-model="user.verifyPassword"
                    append-icon="lock"
                    label="Re-enter password"
                    type="password"
                  />
                </v-form>
              </v-card-text>
              <v-spacer />
              <v-btn
                block
                color="primary"
                :loading="loading"
                @click="completeRegistration"
                :disabled="!validUser"
              >
                Complete Registration
              </v-btn>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { User } from "@/classes";
import { assign } from "lodash";
import request from "@/modules/request";
import settingsMixin from "../../mixins/settingsMixin";

export default {
  name: "UserInvite",
  mixins: [settingsMixin],
  data() {
    return {
      loading: false,
      user: {
        firstName: null,
        lastName: null,
        email: null,
        password: null,
        phoneNumber: null,
        verifyPassword: null,
      },
      token: null,
    };
  },
  computed: {
    validUser() {
      return this.user.password === this.user.verifyPassword;
    },
  },
  mounted() {
    localStorage.removeItem("token");
    const { firstName, lastName, email, phoneNumber } = this.$route.query;
    setTimeout(() => {
      assign(this.user, {
        firstName,
        lastName,
        email,
        phoneNumber,
      });
    }, 500);
    ``;
  },
  methods: {
    async completeRegistration() {
      const { user, token } = this;
      await request
        .callInternal({
          method: "post",
          route: `/api/inviteduser/complete-registration`,
          data: { ...user, token },
        })
        .then((results) => {
          localStorage.setItem("token", results.data.token);
          this.$router.push({ name: "Dashboard" });
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
};
</script>

<style scoped>
.split-bg {
  height: 50%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
  z-index: 0;
}
</style>
